import { render, staticRenderFns } from "./fullPage.vue?vue&type=template&id=11674c82&scoped=true&"
import script from "./fullPage.vue?vue&type=script&lang=js&"
export * from "./fullPage.vue?vue&type=script&lang=js&"
import style0 from "./fullPage.vue?vue&type=style&index=0&id=11674c82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11674c82",
  null
  
)

export default component.exports